import { render, staticRenderFns } from "./depart.vue?vue&type=template&id=52ca3fd2"
import script from "./depart.vue?vue&type=script&lang=js"
export * from "./depart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports